import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import constant from '../../constant';
import ItemForm from '../../components/ui/itemform';
import { ArrowLeft } from 'lucide-react';

const AddItem = () => {
  const [name, setName] = useState('');
  const [gstRate, setGstRate] = useState('');
  const [price, setPrice] = useState('');
  const [isTaxInclusive, setIsTaxInclusive] = useState(false);
  const [itemType, setItemType] = useState('');
  const [hsnCode, setHsnCode] = useState('');
  const [unit, setUnit] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleSubmit = async (itemData) => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        return;
      }

      const response = await fetch(`${constant.REACT_APP_API_URL}/item`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(itemData),
      });

      const result = await response.json();

      if (response.ok) {
        navigate('/items');
      } else {
        setError(result.message || 'Failed to add item');
      }
    } catch (error) {
      setError('Error adding item');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/items');
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (


    <div className="min-h-screen bg-gray-50 p-6 pt-20 md:pt-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-center space-x-4">
            <button onClick={handleBack} className="text-gray-500 hover:text-gray-700 transition-colors">
              <ArrowLeft className="h-6 w-6" />
            </button>
            <h2 className="text-2xl font-bold text-gray-800">Add Item</h2>
          </div>
        </div>
        {loading && (
          <div className="bg-blue-50 text-blue-700 p-4 rounded-lg mb-6">
            Processing...
          </div>
        )}
        {error && (
          <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6">
            {error}
          </div>
        )}

        <ItemForm
          name={name}
          setName={setName}
          gstRate={gstRate}
          setGstRate={setGstRate}
          price={price}
          setPrice={setPrice}
          isTaxInclusive={isTaxInclusive}
          setIsTaxInclusive={setIsTaxInclusive}
          itemType={itemType}
          setItemType={setItemType}
          hsnCode={hsnCode}
          setHsnCode={setHsnCode}
          unit={unit}
          setUnit={setUnit}
          loading={loading}
          isEditing={false}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          error={error}
        />

      </div>
    </div>


  );
};

export default AddItem;
